// extracted by mini-css-extract-plugin
module.exports = {"doubleInfo":"DoubleWorkers_doubleInfo__MPaTJ","grid":"DoubleWorkers_grid__qzejh","accept":"DoubleWorkers_accept__2pUb0","moment":"DoubleWorkers_moment__2T4CY"};